import { SaveButton } from "components/Buttons"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, Input, Label, Row } from "reactstrap"
import Table from "components/Table"
import categoriesListColumns from "./categoriesListColumns"
import { withRouter } from "react-router-dom"
import {
  createCategory,
  deleteCategory,
  editCategory,
  getCategories,
  hideCategoryErrorModal,
  hideDeleteCategoryModal,
  hideEditCategoryModal,
  openDeleteCategoryModal,
  openEditCategoryModal,
} from "store/actions"
import ModalComponent from "components/Modals"
import DeleteCategoryModal from "containers/Categories/deleteCategoryModal"
import ErrorMessageModal from "containers/Categories/errorMessageModal"

const CategoriesTab = ({
  categories,
  getCategories,
  deleteCategory,
  hideDeleteCategoryModal,
  openDeleteCategoryModal,
  isDeleteCategoryModalOpen,
  vendorId,
  isEditCategoryModalOpen,
  hideEditCategoryModal,
  openEditCategoryModal,
  editCategory,
  createCategory,
  hideCategoryErrorModal,
  isCategoryErrorModalOpen,
  error,
  loading,
}) => {
  const [searchValue, setSearchValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState()
  const [newCategoryValue, setNewCategoryValue] = useState("")

  const openDeleteModal = category => {
    openDeleteCategoryModal()
    setSelectedCategory(category)
  }

  const openEditModal = category => {
    openEditCategoryModal()
    setSelectedCategory(category)
    setNewCategoryValue(category?.name)
  }

  const actions = [
    {
      name: "Edit",
      onClick: openEditModal,
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: openDeleteModal,
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const handleSearch = () => {
    if (searchValue.trim().length) {
      getCategories({ type: 2, search: searchValue })
      setShowResetButton(true)
    }
  }

  const handleResetSearch = () => {
    getCategories({ type: 2 })
    setSearchValue("")
    setShowResetButton(false)
  }

  const handleDelete = () => {
    deleteCategory({
      categoryId: selectedCategory.id,
      callback: () => {
        getCategories({
          type: 2,
          ...(searchValue.trim().length ? { search: searchValue } : {}),
        })
      },
    })
  }

  const handleAddNewCategory = () => {
    if (newCategoryValue.trim().length) {
      createCategory({
        values: {
          vendor_id: parseInt(vendorId),
          name: newCategoryValue,
          type: 2,
          inventory: 0,
        },
        callback: () => {
          getCategories({
            type: 2,
            ...(searchValue.trim().length ? { search: searchValue } : {}),
          })
          hideEditCategoryModal()
          setNewCategoryValue("")
        },
      })
    }
  }

  return (
    <React.Fragment>
      <Row className="my-3 d-flex justify-content-end">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Add Category"
            onClick={() => {
              openEditCategoryModal()
              setSelectedCategory(null)
              setNewCategoryValue("")
            }}
          />
        </Col>
      </Row>
      <Row className="my-3 d-flex justify-content-center">
        <Col xs="auto">
          <Input
            placeholder="Search"
            value={searchValue}
            onChange={event => {
              setSearchValue(event.target.value)
            }}
          />
        </Col>
        <Col xs="auto">
          <SaveButton type="button" content="Search" onClick={handleSearch} />
        </Col>
        {showResetButton && (
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Reset"
              onClick={handleResetSearch}
              color="light"
            />
          </Col>
        )}
      </Row>
      <Row>
        <Col>
          <Table
            columns={categoriesListColumns()}
            data={categories}
            actions={actions}
          />
        </Col>
      </Row>
      <ModalComponent
        open={isDeleteCategoryModalOpen}
        onClose={() => {
          hideDeleteCategoryModal()
          setSelectedCategory(null)
        }}
        title={`Delete category - "${selectedCategory?.name}"`}
      >
        <DeleteCategoryModal
          hideModalHandler={() => {
            hideDeleteCategoryModal()
            setSelectedCategory(null)
          }}
          handleDelete={handleDelete}
        />
      </ModalComponent>
      <ModalComponent
        open={isEditCategoryModalOpen}
        onClose={() => {
          hideEditCategoryModal()
          setSelectedCategory(null)
        }}
        title={
          !!selectedCategory
            ? `Edit category - "${selectedCategory?.name}"`
            : "Create Category"
        }
      >
        <Row>
          <Col xs={12} className="mb-3">
            <Label for="categoryName">Name</Label>
            <Input
              value={newCategoryValue}
              id="categoryName"
              onChange={event => {
                setNewCategoryValue(event.target.value)
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={() => {
                hideEditCategoryModal()
                setSelectedCategory(null)
              }}
            />
          </Col>
          <Col>
            <SaveButton
              content="Save"
              fullWidth={true}
              loading={loading}
              disabled={newCategoryValue.trim().length === 0}
              onClick={() => {
                if (newCategoryValue.trim().length) {
                  if (!!selectedCategory) {
                    editCategory(selectedCategory.id, {
                      vendor_id: parseInt(vendorId),
                      name: newCategoryValue,
                      type: 2,
                      delete_file: 0,
                      delete_banner: 0,
                      inventory: 0,
                    })
                  } else {
                    handleAddNewCategory()
                  }
                }
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        open={isCategoryErrorModalOpen}
        onClose={hideCategoryErrorModal}
      >
        <ErrorMessageModal
          onClose={hideCategoryErrorModal}
          message={error?.data?.error?.name}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  categories: state.Categories.categories,
  isEditCategoryModalOpen: state.Categories.isEditCategoryModalOpen,
  isDeleteCategoryModalOpen: state.Categories.isDeleteCategoryModalOpen,
  isCategoryErrorModalOpen: state.Categories.isCategoryErrorModalOpen,
  error: state.Categories.error,
  vendorId: state.Login.vendorId,
  loading: state.Categories.loading,
})

const mapDispatchToProps = dispatch => ({
  getCategories: values => dispatch(getCategories(values)),
  deleteCategory: values => dispatch(deleteCategory(values)),
  hideDeleteCategoryModal: () => dispatch(hideDeleteCategoryModal()),
  openDeleteCategoryModal: () => dispatch(openDeleteCategoryModal()),
  hideEditCategoryModal: () => dispatch(hideEditCategoryModal()),
  openEditCategoryModal: () => dispatch(openEditCategoryModal()),
  hideCategoryErrorModal: () => dispatch(hideCategoryErrorModal()),
  editCategory: (categoryId, data) => dispatch(editCategory(categoryId, data)),
  createCategory: values => dispatch(createCategory(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CategoriesTab))
